import React, { useContext, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import IntlMessages from '../../../utils/IntlMessages';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import Divider from '@mui/material/Divider';
import { Box } from '@material-ui/core';
import { AuhMethods } from '../../../../services/auth';
import ContentLoader from '../../ContentLoader';
import { alpha, makeStyles } from '@material-ui/core/styles';
import CmtImage from '../../../../@coremat/CmtImage';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { CurrentAuthMethod } from '../../../constants/AppConstants';
import { NavLink } from 'react-router-dom';
import AuthWrapper from './AuthWrapper';
import { useSelector } from 'react-redux';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { Alert, FormHelperText } from '@mui/material';
import { useEffect } from 'react';

import { AuthContext } from 'react-oauth2-code-pkce';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const useStyles = makeStyles(theme => ({
  root: {
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  zIndex: 1300,
  overflowY: 'auto',          // lets the page scroll on small screens / when the keyboard opens
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'flex-start',   // see the note below on centering
  justifyContent: 'center',
  padding: theme.spacing(3),
  backgroundColor: '#dfe2f0', // solid, so nothing shows through. Or theme.palette.primary.main
  [theme.breakpoints.down('xs')]: {
    padding: theme.spacing(1.5),
  },
},
card: {
  width: '100%',
  maxWidth: 440,
  margin: 'auto',             // centers the card vertically and horizontally, and scrolls safely when tall
  boxSizing: 'border-box',
  backgroundColor: '#fff',
  borderRadius: 16,
  boxShadow: '0 10px 30px rgba(16,24,40,0.12)',
  padding: 40,
  [theme.breakpoints.down('xs')]: {
    padding: 24,
    borderRadius: 12,
  },
},
  logo: {
    textAlign: 'center',
    marginBottom: theme.spacing(4),
    '& img': { maxWidth: '100%', height: 'auto' },
  },
  titleRoot: {
    marginBottom: 14,
    color: theme.palette.text.primary,
  },
  textFieldRoot: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: alpha(theme.palette.common.dark, 0.12),
    },
  },
  texterror: { color: 'red' },
  formcontrolLabelRoot: {
    '& .MuiFormControlLabel-label': {
      [theme.breakpoints.down('xs')]: { fontSize: 12 },
    },
  },
}));
const logoUrl = '/images/microsoft/images.jpg';
//variant = 'default', 'standard'
const LoginButton = () => {
  const { logIn, token } = useContext(AuthContext);
  useEffect(() => {
    console.log(token, 'token');
  }, [token]);
  return <Button onClick={logIn}>login with microsoft</Button>;
};
const SignIn = ({ method = CurrentAuthMethod, variant = 'default', wrapperVariant = 'default' }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailErr, setEmailErr] = useState(false);
  const [passErr, setPassErr] = useState(false);
  const [isRemember, setIsRemember] = useState(false);
  const dispatch = useDispatch();
  const classes = useStyles({ variant });
  const { authUser } = useSelector(({ auth }) => auth);
  const onSubmit = () => {
    dispatch(AuhMethods[CurrentAuthMethod].onLogin({ email, password, isRemember }));
  };
  const { logIn, token } = useContext(AuthContext);

  const history = useHistory();
  const [showPassword, setShowPassword] = React.useState(false);

  const [isEnterPressed, setIsEnterPressed] = useState(false);
  // const { token, tokenData, logIn } = useContext(AuthContext);
  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      setIsEnterPressed(true);
    }
  };

  // Only use the hook if we’re on the redirect page
  useEffect(() => {
    if (isEnterPressed) {
      onSubmit(); // Call the login function when Enter key is pressed
      setIsEnterPressed(false); // Reset the state
    }

    // Add event listener to listen for keydown events
    document.addEventListener('keydown', handleKeyPress);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [isEnterPressed]);

  const handleClickShowPassword = () => setShowPassword(show => !show);

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  // useEffect(() => {
  //   if (isAuthenticated() && accessToken) {
  //     // 🔽 Call your function here
  //     //fetchUserData(accessToken);
  //     console.log(accessToken, 'we got a access token');
  //   }
  // }, [isAuthenticated, accessToken]);
  // useEffect(() => {
  //   if (token) {
  //     alert(token, 'token');
  //     getSSO(token);
  //   }
  // }, [token]);
  const validateEmail = val => {
    let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regEmail.test(val)) {
      setEmailErr(true);
    } else {
      setEmailErr(false);
      setEmail(val);
    }
  };

  const validatePass = val => {
    let regPassword = /^\s+$|^$/gi;
    if (regPassword.test(val)) {
      setPassErr(true);
    } else {
      setPassErr(false);
      setPassword(val);
    }
  };

  // const authHandler = (err, data) => {
  //   if (err) {
  //     console.error('Login Error:', err);
  //   } else {
  //     getSSO(data.accessToken);
  //   }
  // };

  console.log(process.env.REACT_APP_API_URL, 'envD');

  const handleLogin = async parms => {
    history.push('/oauth-redirect');
    // console.log(parms, 'parms');
    // logIn();
  };
  return (
    <Box className={classes.root}>
      <Box className={classes.card}>
        <Box className={classes.logo}>
          <CmtImage src={'/images/focus-logo/logwatchLogo.jpg'} width={'200px'} />
        </Box>

        <Typography component="div" variant="h1" className={classes.titleRoot}>
          Login
        </Typography>

        {new URLSearchParams(window.location.search).get('reason') === 'not_allowed' && (
          <Alert severity="error" sx={{ mb: 2 }}>You don't have access to this portal.</Alert>
        )}

        <form onSubmit={e => e.preventDefault()}>
          <Box mb={2}>
            <TextField
              error={emailErr}
              label={<IntlMessages id="appModule.email" />}
              fullWidth
              onChange={event => validateEmail(event.target.value)}
              defaultValue={email}
              margin="normal"
              variant="outlined"
              helperText={emailErr ? 'Enter valid email address' : ''}
              className={classes.textFieldRoot}
            />
          </Box>

          <Box mb={2}>
            <FormControl sx={{ mt: 1, width: '100%' }} variant="outlined">
              <InputLabel htmlFor="outlined-adornment-password">
                <IntlMessages id="appModule.password" />
              </InputLabel>
              <OutlinedInput
                error={passErr}
                fullWidth
                onChange={event => validatePass(event.target.value)}
                defaultValue={password}
                className={classes.textFieldRoot}
                id="outlined-adornment-password"
                type={showPassword ? 'text' : 'password'}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Password"
              />
              <FormHelperText id="component-error-text" className="error-password">
                {passErr ? 'Enter your password' : ''}
              </FormHelperText>
            </FormControl>
          </Box>

          <Box display="flex" flexWrap="wrap" alignItems="center" justifyContent="space-between" mb={3}>
            <FormControlLabel
              className={classes.formcontrolLabelRoot}
              control={<Checkbox name="checkedA" onChange={() => setIsRemember(preV => !preV)} />}
              label="Remember me"
            />
            <Box component="p" fontSize={{ xs: 12, sm: 16 }} m={0}>
              <NavLink to="/forgot-password">
                <IntlMessages id="appModule.forgotPassword" />
              </NavLink>
            </Box>
          </Box>

          <Button onClick={onSubmit} variant="contained" color="primary" fullWidth size="large">
            <IntlMessages id="appModule.signIn" />
          </Button>

          <Box textAlign="center" mt={2} fontSize={{ xs: 12, sm: 16 }}>
            <NavLink to="/signup">
              <IntlMessages id="signIn.signUp" />
            </NavLink>
          </Box>
        </form>

        {dispatch(AuhMethods[method].getSocialMediaIcons())}
        <ContentLoader />

        <div className="my-3">
          <Divider>Or continue with</Divider>
        </div>

        <Button
          onClick={handleLogin}
          fullWidth
          variant="outlined"
          startIcon={<img src={logoUrl} width={'24px'} alt="" />}>
          Login With Microsoft
        </Button>
      </Box>
    </Box>
  );
};

export default SignIn;
